import React, { useEffect, useRef, useState } from 'react';
import { makeStyles } from '@mui/styles';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import CallEndIcon from '@mui/icons-material/CallEnd';
import AddIcCallIcon from '@mui/icons-material/AddIcCall';
import MicOffIcon from '@mui/icons-material/MicOff';
import PhonePausedIcon from '@mui/icons-material/PhonePaused';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import { CallTransferIcon, CallResumeIcon } from 'components/icons';
import Button from 'components/Button';
import CallerID from './CallerID';
import { formatDuration, formatPhoneNumber, getName } from 'utils';
import CallTransfer from './CallTransfer';
import AddPerson from './AddPerson';
import DialPad from './DialPad';
import CallParticipants from './CallParticipants';

const useStyle = makeStyles((theme) => ({
  actionButton: {
    'borderColor': 'transparent',
    'height': 60,
    '&:hover': {
      borderColor: 'currentColor',
    },
  },
}));

const OnCall = ({ onHangUp, call }) => {
  const classes = useStyle();
  const timer = useRef();
  const [digits, setDigits] = useState('');
  const [seconds, setSeconds] = useState(0);
  const [showTransfer, setShowTransfer] = useState(false);
  const [showDialPad, setShowDialPad] = useState(false);
  const [showAddPerson, setShowAddPerson] = useState(false);

  useEffect(() => {
    timer.current = setInterval(() => {
      setSeconds((seconds) => seconds + 1);
    }, 1000);
    return () => clearInterval(timer.current);
  }, []);

  const onTransferDone = (caller) => {
    setShowTransfer(false);
  };

  const onDialChange = (val) => {
    setDigits((prev) => `${prev}${val}`);
    call.sendDigits(String(val));
  };

  const toggleMute = () => {
    call.mute(!call.isMuted());
  };

  const onAddPerson = () => {};

  const { customParameters, parameters, direction } = call;
  const isIncoming = direction === 'INCOMING';
  // console.log({ customParameters, parameters });

  const number = isIncoming ? parameters.From : customParameters.get('To');
  const params = Object.fromEntries(customParameters.entries());
  const isMuted = call.isMuted();

  console.log(params);

  if (showTransfer) {
    return (
      <CallTransfer
        onAdded={onTransferDone}
        onClose={() => setShowTransfer(false)}
        callSid={parameters.CallSid}
      />
    );
  }

  if (showAddPerson) {
    return (
      <AddPerson
        onAdded={onAddPerson}
        onClose={() => setShowAddPerson(false)}
        callSid={parameters.CallSid}
      />
    );
  }

  return (
    <Box textAlign="center">
      {showDialPad ? (
        <>
          <Box p={3}>
            <Typography textAlign="center" variant="h3">
              {digits}
            </Typography>
          </Box>
          <DialPad canDial onChange={onDialChange} mode="dtmf" />
        </>
      ) : (
        <Box p={3}>
          <Typography fontWeight={500} variant="subtitle1">
            {isIncoming ? 'Incoming Call' : 'Outgoing Call'}
          </Typography>
          <Typography textAlign="center" fontWeight={500}>
            {formatDuration(seconds * 1000)}
          </Typography>
          <CallerID
            callSid={parameters.CallSid}
            from={formatPhoneNumber(number)}
            name={getName(params)}
          />
          <Box>
            <CallParticipants callSid={parameters.CallSid} />
          </Box>
          <Stack direction="row" justifyContent="center" spacing={2}>
            <Stack spacing={0.5} alignItems="center">
              <Button
                onClick={toggleMute}
                size="large"
                variant="outlined"
                sx={{
                  bgcolor: isMuted ? 'error.lighter' : 'background.default',
                  color: isMuted ? 'error.main' : 'text.secondary',
                }}
                className={classes.actionButton}
              >
                <MicOffIcon sx={{ color: 'inherit' }} />
              </Button>
              <Typography variant="body2">Mute</Typography>
            </Stack>
            <Stack spacing={0.5} alignItems="center">
              <Button
                onClick={() => setShowTransfer(true)}
                size="large"
                variant="outlined"
                sx={{
                  backgroundColor: 'background.default',
                  color: 'text.secondary',
                }}
                className={classes.actionButton}
              >
                <AddIcCallIcon sx={{ color: 'inherit' }} />
              </Button>
              <Typography variant="body2">Transfer</Typography>
            </Stack>
            <Stack spacing={0.5} alignItems="center">
              <Button
                onClick={() => setShowAddPerson(true)}
                size="large"
                variant="outlined"
                sx={{
                  bgcolor: 'background.default',
                  color: 'text.secondary',
                }}
                className={classes.actionButton}
              >
                <PersonAddIcon sx={{ color: 'inherit' }} />
              </Button>
              <Typography variant="body2">Add</Typography>
            </Stack>
          </Stack>
          <Box mt={3}>
            <Button
              fullWidth
              sx={{
                borderRadius: 30,
              }}
              onClick={onHangUp}
              color="error"
              startIcon={<CallEndIcon />}
            >
              Hang up
            </Button>
          </Box>
        </Box>
      )}

      <Box
        bgcolor="background.default"
        py={1}
        sx={{ cursor: 'pointer' }}
        onClick={() => setShowDialPad(!showDialPad)}
      >
        <Typography variant="body2">
          {showDialPad ? 'Hide dialpad' : 'Show dialpad'}
        </Typography>
      </Box>
    </Box>
  );
};

export default OnCall;
